import Valuation from '../valuation/main';
// import { isNullOrUndefined } from 'util';
// import { isNull } from 'util';
// test commit

export const getValuation = (symbol, fmp, ivv, reuters, growth, PM, PE) => {
  
  let valuation = new Valuation(symbol, fmp, ivv, reuters);

  if (growth === null && PM === null && PE === null) {
    // Get initial valuation
    return {
      roundedValuation: valuation.roundedValuation(),
      practicalValuation: valuation.practicalValuation,
      irPractical: valuation.irPractical,
      irPotential: valuation.irPotential,
      buySell: valuation.buyRange(),
      graphData: valuation.graphData(),
      priceMomentum: valuation.priceMomentum(),
      currentSalesGrowth: valuation.marketImpliedSalesGrowth,
      currentInvestmentReturn: valuation.priceRa1,
      practicalGrowthFactor: valuation.practicalG,
      theoreticalGrowthFactor: valuation.theoreticalGrowthFactor,
      theoreticalGDefault: valuation.theoreticalGDefault,
      futurePMFactor: valuation.futurePMFactor,
      futurePMDefault: valuation.futurePMDefault,
      futurePEFactor: valuation.futurePEFactor,
      futurePEDefault: valuation.futurePEDefault,
      industryGrowthFactor: valuation.industryGSlope,
      industryPMFactor: valuation.industryPM,
      industryPEFactor: valuation.industryPE,
      sp500GrowthFactor: valuation.sp500GSlope,
      sp500PMFactor: valuation.sP500_pm,
      sp500PEFactor: valuation.sP500_pe,
      lowBuyRange: valuation.lowBuyRange,
      highBuyRange: valuation.highBuyRange,
      userGrowthFactor: null,
      userPMFactor: null,
      userPEFactor: null,
      companyGrowthFactor: valuation.SalesRecentg,
      companyPMFactor: valuation.CompanyPMAvg,
      companyPEFactor: valuation.PEAvgCompany,
      pmGrowth: valuation.pmGrowth,
      earningsGrowth: valuation.earningsGrowth,
      analystsGrowth: valuation.analystsGrowth,
      futureR: valuation.futureR,
      futureCoE: valuation.futureCoE,
      futureEarningsGrowth: valuation.futureEarningsGrowth,
      futureRf: valuation.futureRf,
      CoEFuturePE: valuation.CoEFuturePE
    };
  } else {
    // Update valuation
    valuation.update(growth, PM, PE);
    return {
      roundedValuation: valuation.roundedValuation(),
      practicalValuation: valuation.practicalValuation,
      irPractical: valuation.irPractical,
      irPotential: valuation.irPotential,
      buySell: valuation.buyRange(),
      graphData: valuation.graphData(),
      priceMomentum: valuation.priceMomentum(),
      currentSalesGrowth: valuation.marketImpliedSalesGrowth,
      currentInvestmentReturn: valuation.priceRa1,
      practicalGrowthFactor: valuation.practicalG,
      theoreticalGrowthFactor: valuation.theoreticalGrowthFactor,
      theoreticalGDefault: valuation.theoreticalGDefault,
      futurePMFactor: valuation.futurePMFactor,
      futurePMDefault: valuation.futurePMDefault,
      futurePEFactor: valuation.futurePEFactor,
      futurePEDefault: valuation.futurePEDefault,
      industryGrowthFactor: valuation.industryGSlope,
      industryPMFactor: valuation.industryPM,
      industryPEFactor: valuation.industryPE,
      sp500GrowthFactor: valuation.sp500GSlope,
      sp500PMFactor: valuation.sP500_pm,
      sp500PEFactor: valuation.sP500_pe,
      userGrowthFactor: valuation.userGrowthFactor,
      userPMFactor: valuation.userPMFactor,
      userPEFactor: valuation.userPEFactor,
      lowBuyRange: valuation.lowBuyRange,
      highBuyRange: valuation.highBuyRange,
      companyGrowthFactor: valuation.SalesRecentg,
      companyPMFactor: valuation.CompanyPMAvg,
      companyPEFactor: valuation.PEAvgCompany,
      pmGrowth: valuation.pmGrowth,
      earningsGrowth: valuation.earningsGrowth,
      analystsGrowth: valuation.analystsGrowth,
      futureR: valuation.futureR,
      futureCoE: valuation.futureCoE,
      futureEarningsGrowth: valuation.futureEarningsGrowth,
      futureRf: valuation.futureRf,
      CoEFuturePE: valuation.CoEFuturePE
    };
  }
};

export const getStockData = (symbol) => {
  // return Promise.all([getYahooData(symbol), getIvvData(), getReutersData(symbol)])
  //   .then(([yahooData, ivvData, reutersData]) => {
  //     return {
  //       yahooData,
  //       ivvData,
  //       reutersData: reutersData.recordset[0]
  //     };
  //   })
  //   .catch((err) => {
  //     console.log('error:', err);
  //   });

    return Promise.all([getfmpData(symbol), getIvvData(), getReutersData(symbol)])
    .then(([fmpData, ivvData, reutersData]) => {
      return {
        fmpData,
        ivvData,
        reutersData: reutersData.recordset[0]
      };
    })
    .catch((err) => {
      console.log('error:', err);
    });
};

export const getfmpData = (symbol) => {
  if (!symbol) {
    console.error('No symbol');
    return null;
  }
  console.log(symbol);
  symbol = symbol.replace('.', '-');
  console.log(symbol);
  return fetch(`${process.env.REACT_APP_API_URI}/api/v1/fmp/${symbol}`)
  .then((res) => {
    let json = res.json();
    return json;
  })
  .then((res) => {
    console.log(res);
    return res;
  })
  .catch((err) => {
    console.log("ERROR FMP", err);
  });
};

export const getYahooData = (symbol) => {
  if (!symbol) {
    console.error('No symbol');
    return null;
  }
  console.log(symbol);
  symbol = symbol.replace('-', '.');
  console.log(symbol);
  return fetch(`${process.env.REACT_APP_API_URI}/api/v3/fmp/${symbol}`)
  .then((res) => {
    let json = res.json();
    return json;
  })
  .then((res) => {
    console.log(res);
    return res;
  })
  .catch((err) => {
    console.log("ERROR FMP", err);
  });
};

const getIvvData = () => {
  return fetch(`${process.env.REACT_APP_API_URI}/api/v1/fmp/ivv`)
  .then((res) => {
    let json = res.json();
    return json;
  })
  .then((res) => {
    console.log(res);
    return res;
  })
  .catch((err) => {
    console.log("ERROR IVV", err);
  });
};

const getReutersData = (symbol) => {
  if (!symbol) {
    console.error('No symbol');
    return null;
  }
  console.log('reuters symbol', symbol);
  // debugger

  return fetch(`${process.env.REACT_APP_API_URI}/api/v1/reuters/${symbol}`)
    .then((res) => {
      let json = res.json();
      return json;
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/lib/stockServices.js